










































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useUiState } from '~/composables';
import type { GoodToKnowPanelModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'GoodToKnowPanel',
  components: {
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoSlider: () => import('molecules/VaimoSlider.vue'),
    VaimoGoodToKnow: () => import('molecules/VaimoGoodToKnow.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<GoodToKnowPanelModel>
    },
    config: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup(props) {
    const declination = computed(() => {
      const declinations = {
        'Option 1: Carousel': 'slider',
        'Option 2: Cards': 'cards'
      };
      return declinations[props.sectionData.mVar] || 'slider';
    });
    const { setTransparencyModalSrc } = useUiState();
    const anchorForIframe = 'transparency';

    function replaceShortcodes(text) {
      const regex = /%(\w+)%/g;
      const descrHasShortcode = text?.match(regex) ?? false;
      if (!descrHasShortcode) return text;

      const data = props.config?.shortcodeSource;
      if (!data) return false;

      let dataHasNoRequiredValue = false;
      const replacedText = text.replace(regex, (match, key) => {
        if (typeof data[key] === 'string') {
          return data[key];
        }
        dataHasNoRequiredValue = true;
        return match;
      });

      return dataHasNoRequiredValue ? false : replacedText;
    }

    const items = computed(() => {
      const items =
        props.sectionData.itemsCollection?.items
          .map((item) => {
            return {
              image: item?.image?.url,
              title: item?.title,
              description: replaceShortcodes(item?.descr),
              link: item?.link,
              label: item?.label
            };
          })
          .filter((item) => {
            return item.image && item.title && item.description;
          }) || [];

      return items;
    });

    const handleClick = (e) => {
      if (
        e.target?.nodeName === 'A' &&
        e.target?.href?.includes(anchorForIframe)
      ) {
        e.preventDefault();
        setTransparencyModalSrc(e.target.href);
      }
      if (
        e.target.offsetParent?.nodeName === 'A' &&
        e.target.offsetParent?.href?.includes(anchorForIframe)
      ) {
        e.preventDefault();
        setTransparencyModalSrc(e.target.offsetParent.href);
      }
    };

    const getDeclinationClasses = computed(() => {
      const rearrangeColsFringe = 5;
      return [
        'declination-' + declination.value,
        items.value.length < rearrangeColsFringe
          ? 'less-than-five'
          : 'five-or-more'
      ];
    });

    const areItemsShown = computed(() => {
      return items.value?.length;
    });

    return {
      declination,
      getDeclinationClasses,
      items,
      handleClick,
      areItemsShown
    };
  }
});
